import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["Tabs"], {
        modelValue: $setup.modelValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.modelValue) = $event))
    }, {
        default: _withCtx(() => [
            _createVNode($setup["TabsList"], null, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tabs, (tab) => {
                        return (_openBlock(), _createElementBlock("div", {
                            id: $setup.getStaticId(tab)
                        }, [
                            _createVNode($setup["TabsTrigger"], {
                                value: $setup.getTabValue(tab),
                                disabled: tab.disabled,
                                onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["prevent"]))
                            }, {
                                default: _withCtx(() => [
                                    (tab.icon)
                                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon), {
                                            key: 0,
                                            class: "size-4"
                                        }))
                                        : _createCommentVNode("v-if", true),
                                    (tab.label)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(tab.label), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "disabled"])
                        ], 8 /* PROPS */, _hoisted_1));
                    }), 256 /* UNKEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tabs, (tab) => {
                return (_openBlock(), _createBlock($setup["TabsContent"], {
                    value: $setup.getTabValue(tab)
                }, {
                    default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, tab.id)
                    ]),
                    _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]));
            }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue"]));
}
